import React, { Component } from 'react';
import MySnackbars from '../components/UI/MySnackbars/MySnackbars';
import { logout } from '../store/actions/userActions';
import store from '../store/reducers/index';
import history from './history';

const withErrorHandler = (WrappedComponent: any, axios: any) => {
  return class extends Component {
    reqInterceptor: any = '';
    resInterceptor: any = '';

    state = {
      error: '',
      variant: 'info'
    };

    componentWillMount() {
      this.reqInterceptor = axios.interceptors.request.use((req: any) => {
        // this.setState({ error: "" });
        return req;
      });
      this.resInterceptor = axios.interceptors.response.use(
        (res: any) => {
          if (res.data) {
            if (res.data.message && res.data.message.length !== 0) {
              this.setState({ error: res.data.message, variant: 'success' });
            }
          }
          return res;
        },
        (error: any) => {
          const originalRequest = error.config;
          const originalRequestUrlArray = originalRequest.url.split('/');

          if (
            error.response &&
            error.response.status === 403 &&
            originalRequestUrlArray[originalRequestUrlArray.length - 1] ===
              'refresh_token'
          ) {
            store.dispatch(logout());
          }

          if (
            error.response &&
            error.response.status === 401 &&
            !originalRequest._retry
          ) {
            originalRequest._retry = true;
            const podUser = JSON.parse(localStorage.getItem('podUser'));
            let refreshToken = '';
            if (podUser) {
              refreshToken = podUser.refresh_token;
            }
            return axios
              .post('/refresh_token', {
                refresh_token: refreshToken,
                email: podUser.email
              })
              .then(res => {
                if (res.status === 200) {
                  const token = res.data.result.token;
                  const user = res.data.result;
                  localStorage.setItem('podToken', token);
                  localStorage.setItem('podUser', JSON.stringify(user));
                  axios.defaults.headers.common.Authorization = token;
                  originalRequest.headers.Authorization = token;
                  return axios(originalRequest);
                }
              });
          } else {
            this.setState({
              error:
                error.response &&
                error.response.data &&
                error.response.data.message
                  ? error.response.data.message
                  : '',
              variant: 'error'
            });
          }

          return error;
        }
      );
    }

    componentWillUnmount() {
      axios.interceptors.request.eject(this.reqInterceptor);
      axios.interceptors.response.eject(this.resInterceptor);
    }

    errorConfirmedHandler = () => {
      this.setState({ error: '', variant: 'info' });
    };

    render() {
      return (
        <React.Fragment>
          {this.state.error !== '' ? (
            <MySnackbars
              open={this.state.error !== ''}
              onClose={this.errorConfirmedHandler}
              message={this.state.error !== '' ? this.state.error : ''}
              variant={this.state.variant}
            />
          ) : null}
          <WrappedComponent {...this.props} />
        </React.Fragment>
      );
    }
  };
};

export default withErrorHandler;
